<template>
  <div class="col-12 p-0 pagination pagination-relative">
    <div class="item-box">
      <div class="box-header">
        <h1 class="fs-20 fc-1">Kampanyalar</h1>
        <div class="slider-dots text-center float-right">
          <span :class="index == pageIndex ? 'active' : ''" v-for="(i, index) in data" :key="index"></span>
        </div>
      </div>
      <carousel @pageChange="pageChanged" :perPage="1" :paginationEnabled="false">
        <slide v-for="item in data" :key="item.slug">
          <div
            class="box-header p-0"
            @click="$router.push({name: 'FanClubDetail', params: {slug: item.id, data: item}})"
          >
            <img :src="item.image" class="w-100" />
          </div>
          <div
            class="box-title bb-1"
            @click="$router.push({name: 'FanClubDetail', params: {slug: item.id, data: item}})"
          >
            <a href="javascript:;">
              <h1 class="fc-2 fs-20">{{ item.name }}</h1>
            </a>
          </div>
          <div class="row no-gutters bg-2 bb-1">
            <div
              class="col-6 br-1"
              @click="$router.push({name: 'FanClubDetail', params: {slug: item.id, data: item}})"
            >
              <div class="block-link text-center pt-3 pb-3">
                <h1 class="fc-1 fs-14">
                  <img src="/static/img/arrow-left.svg" class="mr-2" /> Kampanya Detayı
                </h1>
              </div>
            </div>
            <div class="col-6" @click="$router.push({name: 'FanClub'})">
              <div class="block-link text-center pt-3 pb-3">
                <h1 class="fc-1 fs-14">
                  <img src="/static/img/four-dot.svg" class="mr-2" /> Tüm Kampanyalar
                </h1>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "CampaignCarousel",
  props: ["data"],
  data() {
    return {
      pageIndex: 0
    };
  },
  methods: {
    pageChanged(index) {
      this.pageIndex = index;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/CampaignCarousel.vue